import { Link } from 'react-router-dom'
import { SEO } from '@/components/layout/SEO'
import { PageHeader, Btn } from '@/components/ui'
import { C } from '@/constants/theme'
import { SERVICES, WA_URL } from '@/constants/data'
import type { Service } from '@/types'
import { useState } from 'react'

interface ServiceCardProps { service: Service }

export function ServiceCard({ service }: ServiceCardProps) {
  const [hov, setHov] = useState(false)
  return (
    <Link
      to="/services"
      style={{ textDecoration: 'none' }}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
    >
      <div style={{
        padding: 28, height: '100%',
        background: hov ? C.blueLight : C.grayLight,
        border: `1px solid ${hov ? C.blue : C.grayBorder}`,
        cursor: 'pointer', transition: 'all 0.25s',
        transform: hov ? 'translateY(-4px)' : 'none',
        boxShadow: hov ? '0 8px 32px rgba(0,174,239,0.12)' : '0 1px 4px rgba(0,0,0,0.04)',
        borderTop: hov ? `3px solid ${C.blue}` : '3px solid transparent',
      }}>
        <div style={{ fontSize: 28, marginBottom: 14 }}>{service.icon}</div>
        <div style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 18, fontWeight: 700, color: C.text, marginBottom: 8 }}>{service.title}</div>
        <div style={{ fontSize: 13, color: C.textMid, lineHeight: 1.7 }}>{service.desc}</div>
        {hov && <div style={{ marginTop: 14, fontSize: 11, color: C.blue, fontFamily: "'Rajdhani', sans-serif", fontWeight: 700, letterSpacing: 2 }}>LEARN MORE →</div>}
      </div>
    </Link>
  )
}

export default function Services() {
  return (
    <>
      <SEO
        title="Our Services"
        description="Windscreen replacement, chip repair, rear & door glass, and anti-smash & grab tinting. SABS-approved mobile auto glass service across Gauteng."
        path="/services"
      />

      <PageHeader label="What We Offer" title="Our Services" />

      <div style={{ background: C.white, minHeight: '80vh' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: '60px 24px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 28 }}>
            {SERVICES.map((s, i) => (
              <div key={i} className="gt-service-row" style={{ display: 'grid', gridTemplateColumns: '1fr 1.4fr', border: `1px solid ${C.grayBorder}`, overflow: 'hidden', boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }}>
                <div style={{ padding: 40, background: C.grayLight, borderRight: `1px solid ${C.grayBorder}`, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <div style={{ fontSize: 44, marginBottom: 16 }}>{s.icon}</div>
                  <h3 style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 26, fontWeight: 700, color: C.text, margin: '0 0 12px' }}>{s.title}</h3>
                  <p style={{ color: C.textMid, lineHeight: 1.7, fontSize: 14, margin: '0 0 24px' }}>{s.desc}</p>
                  <a href={WA_URL} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', display: 'inline-block' }}>
                    <Btn size="sm">Request This Service</Btn>
                  </a>
                </div>
                <div style={{ padding: 40, background: C.white, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <div style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 11, letterSpacing: 3, color: C.blue, textTransform: 'uppercase', marginBottom: 20 }}>Includes</div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    {s.features.map((f, fi) => (
                      <div key={fi} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <div style={{ width: 18, height: 18, background: C.blue, clipPath: 'polygon(0 0, 80% 0, 100% 50%, 80% 100%, 0 100%)', flexShrink: 0 }} />
                        <span style={{ color: C.textMid, fontSize: 14 }}>{f}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Can't find CTA */}
          <div style={{ marginTop: 48, background: C.blueLight, border: `1px solid rgba(0,174,239,0.2)`, padding: '32px 40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 20 }}>
            <div>
              <div style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 11, letterSpacing: 3, color: C.blue, textTransform: 'uppercase', marginBottom: 6 }}>Not sure what you need?</div>
              <div style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 20, fontWeight: 700, color: C.text }}>Describe the damage and we'll advise.</div>
            </div>
            <a href={WA_URL} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
              <Btn>Get a Free Quote</Btn>
            </a>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) { .gt-service-row { grid-template-columns: 1fr !important; } }
      `}</style>
    </>
  )
}
